import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { CalGuardService, } from '@cvx/cal-angular';
import { NextPageRoute, NextPageService } from '@cvx/nextpage';
import { QueryListComponent } from './modules/clarification-query/query-list/query-list.component';
import { HomeComponent } from './pages/home/home.component';
import { UnAuthoriseComponent } from './pages/unauthorise/unauthorise.component';
import { RespondedQueryComponent } from './modules/clarification-query/responded-query/responded-query.component';
import { MyQueryListComponent } from './modules/clarification-query/my-query-list/my-query-list.component';
import { DepartmentComponent } from './modules/admin/department/department.component';
import { SubDepartmentComponent } from './modules/admin/sub-department/sub-department.component';
import { CompanyComponent } from './modules/admin/company/company.component';
import { DepartmentApproversComponent } from './modules/admin/department-approvers/department-approvers.component';
import { HolidayComponent } from './modules/admin/holiday/holiday.component';
import { ManageUserComponent } from './modules/admin/manage-user/manage-user.component';
import { PendingQueryComponent } from './modules/clarification-query/pending-query/pending-query.component';
import { AdminGuard } from './core/guards/admin.guard';
import { ReportComponent } from './modules/report/report/report.component';
import { AddUserComponent } from './modules/admin/add-user/add-user.component';

export const routes: Route[] = [
  {
    path: '',
    title: 'Home',
    component: HomeComponent,
    canActivate: [CalGuardService]
  },
  {
    path: 'home',
    title: 'Home',
    component: HomeComponent,
    canActivate: [CalGuardService]
  },
  { 
    path: 'clarification-query', 
    loadChildren: () => import('./modules/clarification-query/clarification-query.module').then((m) => m.ClarificationQueryModule),
    canActivate: [CalGuardService] 
  },  
  // {
  //   path: 'clarification-query',
  //   title: 'Request for Clarification',
  //   children: [
  //     { title: 'All Query Request', path: 'all_query_request', component: QueryListComponent, canActivate: [CalGuardService] },
  //     { title: 'My Query', path: 'my-query', component: MyQueryListComponent, canActivate: [CalGuardService] },
  //     { title: 'Pending Query', path: 'pending_query', component: PendingQueryComponent, canActivate: [CalGuardService] },
  //     { title: 'Responded Query', path: 'responded_query', component: RespondedQueryComponent, canActivate: [CalGuardService] }
  //   ],
  // },
  {
    path: 'admin',
    title: 'Adminstration',
    canActivate: [CalGuardService, AdminGuard],
    children: [
      {
        title: 'User Details', path: 'user_details', component: ManageUserComponent
      },
      {
        title: 'Departments', path: 'departments', component: DepartmentComponent
      },
      {
        title: 'Sub Departments', path: 'sub_departments', component: SubDepartmentComponent
      },
      {
        title: 'Company', path: 'company', component: CompanyComponent
      },
      {
        title: 'Dep Rep/JV Advisor Mapping', path: 'dep_jv', component: DepartmentApproversComponent
      },
      {
        title: 'Holiday', path: 'holiday', component: HolidayComponent, canActivate: [CalGuardService]
      },
      {
        path: 'add-user', component: AddUserComponent, canActivate: [CalGuardService]
      }
    ],
  },
  {
    path: 'report',
    title: 'Report',
    component: ReportComponent,
    canActivate: [CalGuardService]
  },
  {
    path: 'sasbu',
    title: 'SASBU Home Page',
    redirectTo: 'https://l.sasbu.chevron.net/web/',
    pathMatch: 'full'
  },
  {
    path: 'help',
    title: 'Help',
    component: HomeComponent,
    canActivate: [CalGuardService]
  },
  { 
    path: 'unauthorized', 
    component: UnAuthoriseComponent, 
    canActivate: [CalGuardService] 
  },
  // Wildcard route to handle redirection
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];

export const npRoutes: NextPageRoute[] = [
  {
    path: '',
    title: 'Home',
    component: HomeComponent,
    canActivate: [CalGuardService]
  },
  {
    path: 'home',
    title: 'Home',
    component: HomeComponent,
    canActivate: [CalGuardService]
  },
  // { 
  //   path: 'clarification-query', 
  //   loadChildren: () => import('./modules/clarification-query/clarification-query.module').then((m) => m.ClarificationQueryModule),
  //   canActivate: [CalGuardService] 
  // },  
  {
    path: 'clarification-query',
    title: 'Request for Clarification',
    children: [
      { title: 'All Query Request', path: 'all_query_request', component: QueryListComponent, canActivate: [CalGuardService] },
      { title: 'My Query', path: 'my-query', component: MyQueryListComponent, canActivate: [CalGuardService] },
      { title: 'Pending Query', path: 'pending-query', component: PendingQueryComponent, canActivate: [CalGuardService] },
      { title: 'Responded Query', path: 'responded_query', component: RespondedQueryComponent, canActivate: [CalGuardService] }
    ],
  },
  {
    path: 'admin',
    title: 'Adminstration',
    canActivate: [CalGuardService, AdminGuard],
    children: [
      {
        title: 'User Details', path: 'user_details', component: ManageUserComponent
      },
      {
        title: 'Departments', path: 'departments', component: DepartmentComponent
      },
      {
        title: 'Sub Departments', path: 'sub_departments', component: SubDepartmentComponent
      },
      {
        title: 'Company', path: 'company', component: CompanyComponent
      },
      {
        title: 'Dep Rep/JV Advisor Mapping', path: 'dep_jv', component: DepartmentApproversComponent
      },
      {
        title: 'Holiday', path: 'holiday', component: HolidayComponent, canActivate: [CalGuardService]
      }
    ],
  },
  {
    path: 'report',
    title: 'Report',
    component: ReportComponent,
    canActivate: [CalGuardService]
  },
  {
    path: 'sasbu',
    title: 'SASBU Home Page',
    redirectTo: 'https://l.sasbu.chevron.net/web/',
    pathMatch: 'full'
  },
  {
    path: 'help',
    title: 'Help',
    component: HomeComponent,
    canActivate: [CalGuardService]
  },
  { path: 'unauthorized', component: UnAuthoriseComponent, canActivate: [CalGuardService] },
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private NP: NextPageService) {

    this.NP.options.navigationRoutes = npRoutes;
    
  }

}
